import { InstructionFormDetails } from '../../commonAfterFormPage/InstructionFormDetails';
import transitionIcon from '@app/images/transition.svg';
import config from '@app/config';
import { hsbcPaymentInstructionsAddress, hsbcPaymentInstructionsLines } from './hsbcAccountDetails';

export const HSBCEuroFormDetails: InstructionFormDetails = {
  instructionsSubTitle: 'supplierValidation.afterRegister.hsbcEuro.nowYouAreRegistered',
  paymentInstructionsTitle: 'supplierValidation.afterRegister.paymentInst',
  paymentInstructionsLines: hsbcPaymentInstructionsLines,
  paymentInstructionsAddress: hsbcPaymentInstructionsAddress,
  currencies: [],
  pleaseNote: {
    pleaseNoteItem: ['supplierValidation.afterRegister.transferMustBe'],
  },
  showWireTransferWarningBox: {
    achWireTransfer: false,
    swiftWireTransfer: false,
  },
  extraInstructions: [{ icon: transitionIcon, text: 'supplierValidation.afterRegister.hsbcEuro.step1' }],
  downloadLink: `${config.supplierValidationAttachmentsUrl}HSBCEUR/en/hsbc-sepa.pdf`,
};
